module.exports = __webpack_public_path__ + "img/polis-car.69f54e1b.png";